export const TransactionHistory = {
    LOADING_TRANSACTIONHISTORY_LIST: "LOADING_TRANSACTIONHISTORY_LIST",
    GET_TRANSACTIONHISTORY_LIST: "GET_TRANSACTIONHISTORY_LIST",
  };